// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeleteReceiptResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/delete_receipt
 * Deletes a payment receipt document
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeleteReceiptResponseDados = boolean;

export type Payroll_DeleteReceiptResponse = ApiResponse<Payroll_DeleteReceiptResponseDados>;

registerResponseContract('Payroll_DeleteReceiptResponse', {})
